import { Injectable } from '@angular/core';
import { OrderTrackingState } from '../core/state/orders.store';
import { LegacyPreferenceStorageService } from './legacy-preference-storage.service';

@Injectable({ providedIn: 'root' })
export class OrderTrackingService {
  constructor(private readonly preferenceStorage: LegacyPreferenceStorageService) {}

  initializeTrackingState(): OrderTrackingState {
    const text = this.preferenceStorage.readString('tracking', '');
    const enabled = this.preferenceStorage.readBoolean('trackingstatus', false);

    return this.buildTrackingState(text, enabled);
  }

  startTracking(text: string): OrderTrackingState {
    this.preferenceStorage.writeString('tracking', text);
    this.preferenceStorage.writeBoolean('trackingstatus', true);
    return this.buildTrackingState(text, true);
  }

  stopTracking(text: string): OrderTrackingState {
    this.preferenceStorage.writeString('tracking', text);
    this.preferenceStorage.writeBoolean('trackingstatus', false);
    return this.buildTrackingState(text, false);
  }

  private buildTrackingState(text: string, enabled: boolean): OrderTrackingState {
    return {
      enabled,
      text,
      tokens: text
        .split(',')
        .map((item) => item.trim())
        .filter(Boolean)
    };
  }
}
